import parser from 'ua-parser-js'

/**
 * Parse user agent to detect if a it is a mobile client.
 * This is to populate initial store and hence styles to fit the users device
 * without triggering additional rerenders.
 * @param {string} userAgent user-agent string
 * @returns Boolean if device is mobile or mobile equivalent
 */
export const isMobile = userAgent => {
  const parsed = parser(userAgent)
  if (parsed && parsed.device && parsed.device.type) {
    switch (parsed.device.type) {
      case 'mobile':
      case 'tablet':
      case 'wearable':
        return true
      default:
        return false
    }
  }
  return false
}

/**
 * Using this to determine if we can use fancy blur css: -webkit-backdrop-filter: blur
 * Otherwise, adapt css accordingly if user-agent is not compatible with "experimental" webkit features
 * @param {*} userAgent user-agent header string
 */
export const isWebkit = userAgent => {
  const parsed = parser(userAgent)
  if (parsed && parsed.browser && parsed.browser.name) {
    switch (parsed.browser.name) {
      case 'Mobile Safari':
      case 'Safari':
      case 'WebKit':
        return true
      default:
        return false
    }
  }
  return false
}
